import { Action } from '@ngrx/store';
import { Order, IHauler } from '@cemex-core/cmx-api';

export enum OneClickHaulersActionTypes {
  LOAD_HAULERS = '[One Click] Load haulers',
  LOAD_HAULERS_COMPLETE = '[One Click] Load haulers completed',
  SELECT_HAULER = '[One Click] Select hauler',
  RESET = '[One Click] Haulers reset',
}

export class OneClickLoadHaulersAction implements Action {
  readonly type = OneClickHaulersActionTypes.LOAD_HAULERS;

  constructor(public payload: Order) {}
}

export class OneClickLoadHaulersCompleteAction implements Action {
  readonly type = OneClickHaulersActionTypes.LOAD_HAULERS_COMPLETE;

  constructor(public payload: IHauler[]) {}
}

export class OneClickSelectHaulerAction implements Action {
  readonly type = OneClickHaulersActionTypes.SELECT_HAULER;

  constructor(public payload: IHauler) {}
}

export class OneClickResetHaulersAction implements Action {
  readonly type = OneClickHaulersActionTypes.RESET;

  constructor() {}
}

export type OneClickHaulersActions =
  | OneClickLoadHaulersAction
  | OneClickLoadHaulersCompleteAction
  | OneClickSelectHaulerAction
  | OneClickResetHaulersAction;
